import { render, staticRenderFns } from "./ChatImage.vue?vue&type=template&id=1b8e5736&"
import script from "./ChatImage.vue?vue&type=script&lang=js&"
export * from "./ChatImage.vue?vue&type=script&lang=js&"
import style0 from "./ChatImage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports